export default function XScroll() {
  document.querySelectorAll(".xScroll").forEach((cont) => {
    //get the actual, scrollable ul
    const list = cont.querySelector(".xScroll__items");
    //get the anchor with the active class
    let active = list.querySelector("[class*='--active'], input[checked]");

    //scroll the list with appropriate offsets to center the active item
    if (active)
      list.scrollLeft =
        active.offsetLeft - (list.clientWidth / 2 - active.clientWidth / 2);

    //add an event listener to adjust the opacity of the :before and :after overlay when the scroll is near the start or end
    list.addEventListener("scroll", (e) => {
      setXScrollOverlay(e.target);
    });
    //check the opacity on load in case we are pre-scrolled
    setXScrollOverlay(list);
  });
  function normalizeOpacity(val) {
    return val > 1 ? 1 : val;
  }
  function setXScrollOverlay(target) {
    const multiplier = 0.04;
    const startOpacity = target.scrollLeft * multiplier;
    const endOpacity =
      (target.scrollWidth - (target.offsetWidth + target.scrollLeft)) *
      multiplier;
    target.style.setProperty(
      "--startFadeOpacity",
      normalizeOpacity(startOpacity)
    );
    target.style.setProperty("--endFadeOpacity", normalizeOpacity(endOpacity));
  }
}
